import { createSlice } from "@reduxjs/toolkit";

const initialCartState = {
  items: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState: initialCartState,
  reducers: {
    add(state, action) {
      // console.log(action.payload);
      const index = state.items.findIndex((el) => el.id === action.payload.id);
      // console.log(index);
      if (index === -1) {
        state.items.unshift({
          id: action.payload.id,
          itemName: action.payload.itemName,
          img: action.payload.img,
          materials: action.payload.materials,
          customizable: action.payload.cutsomizable,
        });
      }
    },
    remove(state, action) {
      state.items = state.items.filter((el) => el.id !== action.payload);
    },

    clear(state) {
      state.items.length = 0;
    },
  },
});

export const cartActions = cartSlice.actions;

export default cartSlice.reducer;
